import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Link, withRouter } from 'react-router-dom'

// import { ZopimChat, Notification } from 'my-components/navigation'

import { CookieService } from 'my-utils/core'
import { RoutesService } from 'my-routes'
import InfoUserContainer from "my-containers/info-user/InfoUserContainer"
import 'my-styles/reactstrap-modal.css'
import { changeLanguage } from 'my-actions/systems/LanguageAction'
import { AuthService } from 'my-services/systems'
import { TransComponent } from 'my-components'
// import { AppConfig } from 'my-constants'

import 'my-styles/styles.css'

class Header extends Component {
    state = {
        isOpenModalBaner: false,
        lang: CookieService.get('lang')
    };

    handleLogout = _ => {
        AuthService.logout();

        if (this.props.isReplaceRouterLink) {
            window.location.href = RoutesService.getPath('ADMIN', 'AUTH_LOGIN', { type: 'login' });
        } else {
            this.props.history.push(RoutesService.getPath('ADMIN', 'AUTH_LOGIN', { type: 'login' }))
        }
    };

    handleChangeLanguage = type => () => {
        CookieService.set('lang', type)
        this.setState({lang: type})
        return this.props.changeLanguage(type)
    };

    render() {
        const status = CookieService.get("status");
        const lang = this.state.lang;
        const isReplaceRouterLink = this.props.isReplaceRouterLink;
        const roles = CookieService.get("roles");

        return (
            <>
                <div className="page-header navbar navbar-fixed-top">
                    <div className="page-header-inner ">
                        <div className="page-logo" style={{paddingLeft: "10px"}}>
                            {
                                isReplaceRouterLink
                                    ? (
                                        <a className="position-relative" href={RoutesService.getPath('ADMIN', 'DASHBOARD')} style={{height: '100%', lineHeight: '18px', color: 'white', fontWeight: 'bold', fontSize: '20px'}}>
                                            <img src="/assets/images/vscan.jpg" style={{width: "100px", height: "45px",  marginTop: "2px"}} alt={'vscan'}/>
                                        </a>

                                    )
                                    : (
                                        <Link className="position-relative" to={RoutesService.getPath('ADMIN', 'DASHBOARD')} style={{height: '100%', lineHeight: '18px', color: 'white', fontWeight: 'bold', fontSize: '20px'}}>
                                            <img src="/assets/images/vscan.jpg" style={{width: "100px", height: "45px",  marginTop: "2px"}} alt={'vscan'} />
                                        </Link>
                                    )
                            }
                            <div className="menu-toggler sidebar-toggler"><span /></div>
                        </div>
                        <a className="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse" href="!#"><span></span></a>
                        {/*=========================================*/}
                        <InfoUserContainer/>
                        {/*=========================================*/}
                        <div className="top-menu">
                            <ul className="nav navbar-nav pull-right">
                                <li className="dropdown dropdown-extended dropdown-inbox" id="header_inbox_bar">
                                    <a className="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true" href="!#">
                                        <i className="icon-globe" />
                                    </a>
                                    <ul className="width-auto dropdown-menu dropdown-menu-default">
                                        <li>
                                            <ul className="dropdown-menu-list scroller" data-handle-color="#637283">
                                                <li>
                                                    <a onClick={this.handleChangeLanguage('en')} className="padding-tb-10-important text-uppercase text-center padding-" >
                                                        {(lang && lang.toLowerCase() === 'en') ? <i className="fa fa-check"/> : ''}&nbsp;&nbsp;<TransComponent i18nKey="english" />
                                                    </a>
                                                </li>
                                                <li>
                                                    {/*<a onClick={this.handleChangeLanguage('vi')} className="padding-tb-10-important text-uppercase text-center" href="!#">*/}
                                                    <a onClick={this.handleChangeLanguage('vi')} className="padding-tb-10-important text-uppercase text-center" >
                                                        {(lang && lang.toLowerCase() === 'vi') ? <i className="fa fa-check"/> : ''}&nbsp;&nbsp;<TransComponent i18nKey="vietnam" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                {
                                    (Number(status) === 1 && Number(roles) !== 13) ?
                                    <>
                                        <li className="dropdown dropdown-user">
                                            <a className="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true" href="!#">
                                                <img className="img-circle" src="/assets/layouts/layout/img/avatar.png" alt="avatar" />
                                                <span className="username username-hide-on-mobile"> {AuthService.getUsername()} </span>
                                                <i className="fa fa-angle-down" />
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-default">
                                                <Fragment>
                                                    <li>
                                                        {
                                                            isReplaceRouterLink
                                                                ? (
                                                                    <a href={RoutesService.getPath('ADMIN', 'CHANGE_PASSWORD')}>
                                                                        <i className="icon-lock" /> <TransComponent i18nKey="Change Password" />
                                                                    </a>
                                                                )
                                                                : (
                                                                    <Link to={RoutesService.getPath('ADMIN', 'CHANGE_PASSWORD')}>
                                                                        <i className="icon-lock" /> <TransComponent i18nKey="Change Password" />
                                                                    </Link>
                                                                )
                                                        }
                                                    </li>
                                                </Fragment>
                                                <li>
                                                    {
                                                        isReplaceRouterLink
                                                            ? <a href={RoutesService.getPath('ADMIN', 'AUTH_LOGOUT' )}> <i className="icon-key" /><TransComponent i18nKey="Logout" /></a>
                                                            : <a onClick={this.handleLogout} href="!#"> <i className="icon-key" /><TransComponent i18nKey="Logout" /></a>
                                                    }
                                                </li>
                                            </ul>
                                        </li>
                                    </> : null
                                }
                                <li className="dropdown dropdown-quick-sidebar-toggler">
                                    {
                                        isReplaceRouterLink
                                            ? <a href={RoutesService.getPath('ADMIN', 'AUTH_LOGOUT' )} className="dropdown-toggle"><i className="icon-logout" /></a>
                                            : <a href="#/" className="dropdown-toggle"  onClick={this.handleLogout}><i className="icon-logout" /></a>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="clearfix"> </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        changeLanguage: type => dispatch(changeLanguage(type)),
    }
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(Header)